import React, { useEffect, useState } from "react";
import { useShowcase } from "@/hooks/useShowcase";
import SiteList from "./SiteList";
import SetupInstall from "./SetupInstall";
import WebsitePreview from "./WebsitePreview";
import { MAX_SITES, hostOf } from "./showcaseSetupModel";
import "./ShowcaseSetup.scss";

export { MAX_SITES, hostOf };

const ShowcaseSetup = ({ brokerageId, brokerageName, previewOnly = false }) => {
  const query = useShowcase(brokerageId);
  const showcase = query.data?.showcase;
  const [draft, setDraft] = useState({});

  useEffect(() => {
    setDraft({});
  }, [brokerageId]);

  if (!showcase) {
    return query.isError ? (
      <div className="showcase-setup__state">
        Your website settings did not load.{" "}
        <button type="button" className="btn btn-link p-0 align-baseline" onClick={() => query.refetch()}>
          Try again
        </button>
      </div>
    ) : (
      <div className="showcase-setup__state" aria-busy="true">
        Loading your website settings…
      </div>
    );
  }

  const look = { look: showcase.look, layout: showcase.layout, headline: showcase.headline, ...draft };
  const live = showcase.checklist?.live;
  const hasSites = (showcase.sites || []).length > 0;

  if (previewOnly) {
    return (
      <section className="content-block showcase-setup showcase-setup--preview-only">
        <WebsitePreview
          brokerageId={brokerageId}
          showcase={showcase}
          look={look}
          onDraft={(next) => setDraft((was) => ({ ...was, ...next }))}
        />
      </section>
    );
  }

  return (
    <section className="content-block showcase-setup">
      <div className="title-sec">
        <h4>Install on your&nbsp;website</h4>
        <p className={`showcase-setup__state-line${live ? " is-live" : ""}`} role="status">
          {live ? "Live on your website" : hasSites ? "Not live yet" : "Add your website to start"}
        </p>
      </div>
      <div className="showcase-setup__layout">
        <div className="showcase-setup__controls">
          {hasSites ? null : <SiteList brokerageId={brokerageId} showcase={showcase} />}
          <SetupInstall brokerageId={brokerageId} brokerageName={brokerageName} showcase={showcase} />
          {hasSites ? <SiteList brokerageId={brokerageId} showcase={showcase} /> : null}
        </div>
        <WebsitePreview
          brokerageId={brokerageId}
          showcase={showcase}
          look={look}
          onDraft={(next) => setDraft((was) => ({ ...was, ...next }))}
        />
      </div>
    </section>
  );
};

export default ShowcaseSetup;
